import { render, staticRenderFns } from "./cropRecord.vue?vue&type=template&id=05705d0c&"
import script from "./cropRecord.vue?vue&type=script&lang=js&"
export * from "./cropRecord.vue?vue&type=script&lang=js&"
import style0 from "./cropRecord.vue?vue&type=style&index=0&id=05705d0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports